import find from 'lodash/find';
import each from 'lodash/each';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import replace from 'lodash/replace';
import filter from 'lodash/filter';
import toLower from 'lodash/toLower';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import concat from 'lodash/concat';
import intersection from 'lodash/intersection';
import map from 'lodash/map';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import Scroll from 'scroll';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import User from 'yoda-site-components/lib/helpers/User/User';
import { ACCOUNT_ID } from 'yoda-site-components/lib/common/Constants';
import TokenProvider, {
    setValue,
} from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { logDAError } from 'yoda-interfaces/lib/Order/OrderApi';
import CustomErrorLogger from 'yoda-site-components/lib/helpers/CustomErrorLogger/CustomErrorLogger';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import {
    PDP_URL_CONFIG_PDP_APPLIANCE_UPSELL,
    PDP_URL_CONFIG_URL_PARAMETERS_INDEX,
    PAYPAL_URL_TEST,
    CHECKOUT_URL,
    JCP_HOSTNAME_MOBILE,
    JCP_HOSTNAME_DESKTOP,
    JCP_HOSTNAME_UNIFIED,
    PAYPAL_URL_PROD,
    PAYPAL_FORCE_WEB,
    SHIPPING_GROUP_TYPE_HOME,
    InventoryStatus,
    URL_PAYMENT_PAGE,
    URL_CHECKOUT_SHIPPING,
    URL_CHECKOUT_PAYMENT,
    URL_SHIPPING_PAGE,
    URL_CART_PAGE,
    URL_REVIEW_PAGE,
    URL_SIGN_IN_PAGE,
    URL_CHECKOUT_PAGE,
    APPLEPAY_ERROR_MAP,
    APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE,
    getItBy,
    getItOn,
    ANALYTICS_ORDER_UID,
    allowedQueryParams,
    ADJUSTMENT_TYPE_NEW_CUSTOMER,
    MAXALLOWEDGIFTCARD,
} from '../../common/Constants';
import { DISCONTINUED_OOS_MESSAGES, OOS_MESSAGES } from '../../common/LabelConstants';

const queryStringToJSON = (queryParams) => {
    const pairs = queryParams.split('&');
    const result = {};
    pairs.forEach((pair) => {
        // eslint-disable-next-line no-param-reassign
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return JSON.parse(JSON.stringify(result));
};

export function getVDataAttributes(result, attr) {
    if (attr.isVdata) {
        // eslint-disable-next-line no-param-reassign
        result += `&${attr.type}=${attr.value}`;
    }
    return result;
}

export function isSyndicateURL(url) {
    return (
        url.includes('sportsfanshop.jcpenney.com') ||
        url.includes('/dotcom/jsp/cart/viewShoppingBag.jsp')
    );
}

export function navigateToPDPPage(
    item,
    editCartToPDPNoAdditionalParamsFF,
    enableCartRedesign = false
) {
    const url = get(item, 'product.url', '');
    try {
        if (isSyndicateURL(url)) {
            window.location.href = url;
        } else {
            // Extract the URL parameters
            const urlSplitValues = url.split('?');
            const attributes = get(item, 'attributes', []);
            const vDataAttributes = attributes.length
                ? attributes.reduce(getVDataAttributes, '')
                : '';

            const urlParameters =
                urlSplitValues.length >= 2
                    ? urlSplitValues[PDP_URL_CONFIG_URL_PARAMETERS_INDEX]
                    : /* istanbul ignore next */
                      '';
            const skuId = item.sku && item.sku.id;
            const deliveryOption = find(item.deliveryOptions, { selected: true });
            const selectedDeliveryCode = deliveryOption && deliveryOption.code;
            const deliveryZipcode = deliveryOption && deliveryOption.zipcode;
            // Find the warranty associated with the item, if one exists
            let warrantyId = 'none';
            if (item.childItems) {
                const [careItem] = item.childItems.filter(
                    (c) =>
                        c.product &&
                        c.sku &&
                        (c.product.type === 'SERVICE' || c.product.type === 'REGULAR')
                );
                warrantyId = careItem ? careItem.sku.id || careItem.id : 'none';
            }
            let pdpUrl = '';
            // TODO: Logic for Gift Registry items need to be handled
            let pTitle = toLower(replace(item.product.name, /[^a-zA-Z ]/g, '')); // remove all special cahrs except space
            pTitle = toLower(replace(pTitle, /\s+/g, '-')); // replace spaces with '-'
            pdpUrl =
                `/p/${pTitle}/${item.product.id}?cartId=${item.id}&qty=${item.quantity}` +
                `&wty=${warrantyId}&selectedSKUId=${skuId}&deliveryOption=${selectedDeliveryCode}` +
                `&updateShoppingbag=${!enableCartRedesign}&commerceId=${item.id}${
                    deliveryZipcode ? `&zipCode=${deliveryZipcode}` : ''
                }` +
                `${vDataAttributes}`;

            pdpUrl += editCartToPDPNoAdditionalParamsFF ? '' : `&${urlParameters}`;
            // Trimming Size Param from URL
            pdpUrl = pdpUrl.replace(/(\?|&)(SIZE=.*?(&|$))/gi, '$1');
            window.location.href = pdpUrl;
        }
    } catch (ex) {
        /* istanbul ignore next */
        window.location.href = url;
    }
}

export function navigateToPDPPageWithoutParams(item) {
    const url = get(item, 'product.url', '');
    try {
        if (isSyndicateURL(url)) {
            window.location.href = url;
        } else {
            const queryParams = url.split('?');
            let appendVal = '?';
            let queryParmaerters = '';
            /* istanbul ignore next */
            if (queryParams.length > 1) {
                const querParamObj = queryStringToJSON(queryParams[1]);
                forEach(allowedQueryParams, (params) => {
                    if (querParamObj[params]) {
                        queryParmaerters = `${queryParmaerters}${appendVal}${params}=${querParamObj[params]}`;
                        appendVal = '&';
                    }
                });
            }
            let pTitle = toLower(replace(item.product.name, /[^a-zA-Z ]/g, '')); // remove all special cahrs except space
            pTitle = toLower(replace(pTitle, /\s+/g, '-')); // replace spaces with '-'
            /* istanbul ignore next */
            window.location.href = `/p/${pTitle}/${item.product.id}${queryParmaerters}`;
        }
    } catch (ex) {
        /* istanbul ignore next */
        window.location.href = url;
    }
}

export function navigateOnCheckout() {
    window.location.href = User.isUserLoggedIn() ? URL_CHECKOUT_PAGE : URL_SIGN_IN_PAGE;
}

export function navigateToCheckoutPage() {
    window.location.href = URL_CHECKOUT_PAGE;
}

export function navigateToEditAppliance(ppId, cartId, itemSkuId, warrantyId) {
    /* istanbul ignore next */
    let zipCode = Cookies.load('APPLIANCE_ZIP') || LocalStorage.getData('APPLIANCE_ZIP', true);
    /* istanbul ignore next */
    zipCode = zipCode ? zipCode.replace(/"/g, '') : 'none';
    const pdpUrl =
        `${PDP_URL_CONFIG_PDP_APPLIANCE_UPSELL}${ppId}&zipCode=${zipCode}&cartId=${cartId}` +
        `&itemId=${itemSkuId}&wty=${warrantyId}`;
    window.location.href = pdpUrl;
}

export function navigateToCheckoutFromInterstitial() {
    window.location.href = CHECKOUT_URL;
}

export function getPayPalUrl() {
    let urlPayPal = PAYPAL_URL_TEST;
    if (
        window.location.hostname === JCP_HOSTNAME_MOBILE ||
        window.location.hostname === JCP_HOSTNAME_DESKTOP ||
        window.location.hostname === JCP_HOSTNAME_UNIFIED
    ) {
        urlPayPal = PAYPAL_URL_PROD;
    }
    return urlPayPal;
}

export function navigateToPayPal(token) {
    const paypalUrl = getPayPalUrl();
    const paypalLink = `${paypalUrl}${token}${PAYPAL_FORCE_WEB}`;
    window.location.href = paypalLink;
}

export function getDateRangeOrSingle(deliveryMsg) {
    return deliveryMsg.indexOf('-') === -1 ? getItOn : getItBy;
}

export function getWarrantyDetails(
    selectedProductLot,
    selectedProtectionPlan,
    enableCarePlanUpdate
) {
    const warranties = [];
    let includedProtectionPlan = [];
    if (get(selectedProductLot, 'warranties', []).length) {
        includedProtectionPlan = selectedProductLot.warranties.filter(
            (warranty) => warranty.selected
        );
        /* sort protection plans from BAPI based on price */
        if (enableCarePlanUpdate) {
            selectedProductLot.warranties.sort(
                /* istanbul ignore next */ (a, b) => b.price - a.price
            );
        }
        selectedProductLot.warranties.forEach((warranty) => {
            if (!warranty.selected) {
                warranties.push({
                    id: warranty.itemId,
                    type: 'service',
                    group: 'care plan',
                    required: true,
                    selected: warranty.itemId === selectedProtectionPlan,
                    name: warranty.name,
                    description: warranty.description,
                    price: warranty.price,
                });
            }
        });
    }
    return { warranties, includedProtectionPlan };
}

export function getCurrentProduct(items, skuId) {
    let services;
    const currentItem = filter(items, (item) => item.sku.id === skuId);
    const childItems = get(currentItem[0], 'childItems', []);
    if (!isEmpty(childItems)) {
        services = filter(childItems, (item) => item.type === 'SERVICE');
    }
    return services;
}

/**
 * This method will iterate through the provided orderItems object
 * and determine if the order contains a gift card
 * @static
 * @param {any} orderItems
 * @returns
 *
 * @memberof Utils
 */
export function isGiftCardOrder(orderItems) {
    let result = false;

    /* istanbul ignore else */
    if (orderItems && orderItems.length > 0) {
        each(orderItems, (item) => {
            /* istanbul ignore else */
            if (item.product && item.product.type === 'GIFTCARD') {
                result = true;
            }
        });
    }

    return result;
}

/**
 * This method will iterate through the provided orderItems object
 * and determine if the order contains not a gift card
 * @static
 * @param {any} orderItems
 * @returns
 *
 * @memberof Utils
 */
export function isGiftCardOrderOnly(orderItems) {
    let result = false;
    if (orderItems && orderItems.length > 0) {
        result = true;
        each(orderItems, (item) => {
            if (item.product && item.product.type !== 'GIFTCARD') {
                result = false;
            }
        });
    }
    return result;
}

export function isAddGiftCardLinkEligible(data) {
    const items = get(data, 'bag.items', []);
    const isGiftCardOrderCheck = isGiftCardOrder(items);
    if (isGiftCardOrderCheck) {
        return false;
    }
    const appliedGiftCard = get(data, 'billing.unnamed.giftCards', []);
    const totals = get(data, 'totals', []);
    const totalBalance = find(totals, { type: 'BALANCE' }) || {};
    return totalBalance.amount > 0 && appliedGiftCard.length < MAXALLOWEDGIFTCARD;
}

export function getClientId(deviceType, isNativeIos = false, isNativeAndroid = false) {
    let clientId = '';

    if (isNativeIos) {
        clientId = 'amNwLmlvczpETndDU1QyZHBi'; // ios App
    } else if (isNativeAndroid) {
        clientId = 'amNwLmFuZHJvaWQ6UDE2TENncmZjWQ'; // Android App
    } else if (deviceType.isDesktop) {
        clientId = 'amNwOnlvZGF3Ojc1NTU4NTk2';
    } else if (deviceType.isMobile) {
        clientId = 'amNwLnJ3ZG06QVVndFRydFc5cg';
    } else if (deviceType.isTablet) {
        clientId = 'amNwLnJ3ZHQ6Uk5hdVJqdUsycw';
    }
    return clientId;
}

/* istanbul ignore next */
export function getFormattedValue(offerReward) {
    let formattedValue = Number(offerReward);
    /* istanbul ignore else */
    // eslint-disable-next-line radix
    if (parseInt(formattedValue, 0) === offerReward) {
        formattedValue = formattedValue.toFixed();
    }
    return formattedValue.toString();
}

/**
 * Navigate user to Review page
 */
/* istanbul ignore next */
export function navigateToReview() {
    getBrowserHistory().push(URL_REVIEW_PAGE);
}

/**
 * This method will scroll to the given element
 * @static
 * @param {any} element
 *
 * @memberof Utils
 */
/* istanbul ignore next */
export function scrollToElement(element, isFixedElement) {
    if (__SERVER__) {
        return;
    }

    // eg. scrolls on a sidebar
    if (element && isFixedElement) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    const topOffset = 50;
    const { top } =
        (element && element.getBoundingClientRect && element.getBoundingClientRect()) || {};

    // scrolls to the element only when it is not visible in the current view
    if ((top && topOffset > top) || !element) {
        const elementTop =
            element && element.offsetTop > topOffset ? element.offsetTop - topOffset : 0;
        const win = typeof window !== 'undefined' ? window : {};
        const doc = typeof document !== 'undefined' ? document : { documentElement: {} };
        let scrollElem = typeof win.pageYOffset === 'undefined' ? doc.documentElement : null;
        /* istanbul ignore next */
        if (!scrollElem) {
            const startScrollTop = win.pageYOffset;
            doc.documentElement.scrollTop = startScrollTop;
            // IE > 9 & FF (standard)
            scrollElem = doc.documentElement;

            // safri does not allow set documentElement.scrollTop
            if (doc.documentElement.scrollTop !== startScrollTop) {
                doc.body.scrollTop = startScrollTop;
                scrollElem = doc.body;
            }
        }
        Scroll.top(scrollElem, elementTop, { duration: 500 });
    }
}

/**
 * This method set background to non scrollable state
 * @static
 * @param {any} status
 *
 * @memberof Utils
 */
export function setBackgroundPageFixed(status) {
    // Pass param to set background page to non scrollable
    /* istanbul ignore next */
    if (__SERVER__) {
        return;
    }
    if (status) {
        document.body.style.position = 'fixed';
        document.body.style.top = 0;
        document.body.style.bottom = 0;
        document.body.style.right = 0;
        document.body.style.left = 0;
        return;
    }
    // pass nothing/false to reset to scrollable
    document.body.style.position = 'inherit';
}

export function getDaFormError(formErrors) {
    const DAformErrors = [];
    each(formErrors.fields, (value, key) => {
        if (value.touched && formErrors.syncErrors[key]) {
            DAformErrors.push({ errorDescription: formErrors.syncErrors[key] });
        }
    });
    return DAformErrors;
}

export function resetCursorPosition(elem) {
    setTimeout(() => {
        elem &&
            elem.setSelectionRange &&
            elem.setSelectionRange(elem.value.length, elem.value.length);
    }, 10);
}

/*
 * return example: 1st or 2nd or 3rd or 4th..
 */
export function getOrdinal(n) {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

/*
 * return name of the day
 */
export function getDayName(day) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[day];
}

/*
 * return name of month
 */
export function getMonthName(month) {
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    return months[month];
}

/*
 * Leading zero if a number is less than 10
 */
export function pad(n) {
    return n < 10 ? `0${n}` : n;
}

/*
 * return example: Saturday, August 26th, 2017
 */
export function getDateFormatOne(d) {
    const dateObj = new Date(d);
    const day = getDayName(dateObj.getDay());
    const month = getMonthName(dateObj.getMonth());
    const date = getOrdinal(dateObj.getDate());
    const year = dateObj.getFullYear();
    return `${day}, ${month} ${date}, ${year}`;
}

/*
 * return example: MM/DD/YYYY
 */
export function getDateFormatTwo(d) {
    const dateObj = new Date(d);
    const month = pad(dateObj.getMonth() + 1);
    const date = pad(dateObj.getDate());
    const year = dateObj.getFullYear();
    return `${month}/${date}/${year}`;
}

/*
 * return example: August 26th 2017
 */
export function getDateFormatThree(d) {
    const dateObj = new Date(d);
    const month = getMonthName(dateObj.getMonth());
    const date = getOrdinal(dateObj.getDate());
    const year = dateObj.getFullYear();
    return `${month} ${date}, ${year}`;
}

/**
 * return example: Apr 10
 * @param {d} date string
 */
export function getDateFormatMmmsDD(d, withYear = false, fullMonths = false) {
    try {
        let months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];

        const fullMonthsList = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        if (fullMonths) {
            months = fullMonthsList;
        }
        const date = new Date(d);
        const year = date.getFullYear();
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(date)) {
            return withYear
                ? `${months[date.getMonth()]} ${date.getDate()}, ${year}`
                : `${months[date.getMonth()]} ${date.getDate()}`;
        }
    } catch (ex) {
        // suppressed
    }
    return d;
}

export function getOrderGiftRegistries(orderDetails) {
    if (isEmpty(orderDetails)) {
        return null;
    }

    // initialize the object to be returned.
    const orderGiftRegistries = {
        itemsPresent: false,
        registries: [],
        items: [],
        shippingGroupId: null,
    };

    /* istanbul ignore else */
    if (
        orderDetails.delivery &&
        orderDetails.delivery.groups &&
        orderDetails.delivery.groups.length > 0
    ) {
        const deliveryGroup = find(orderDetails.delivery.groups, {
            type: SHIPPING_GROUP_TYPE_HOME,
        });
        deliveryGroup && (orderGiftRegistries.shippingGroupId = deliveryGroup.id);
    }

    // iterate through the bag items and update the gift registry item status.
    /* istanbul ignore else */
    if (orderDetails && orderDetails.bag && !isEmpty(orderDetails.bag.items)) {
        each(orderDetails.bag.items, (item) => {
            const arrayItem = {};
            arrayItem.itemId = item.id;
            arrayItem.manualGift = true; // assuming the item is a regular non gift registry item.

            /* istanbul ignore else */
            if (!isEmpty(item.giftRegistry)) {
                arrayItem.regId = item.giftRegistry.id;
                arrayItem.regName = item.giftRegistry.name;
                arrayItem.regType = item.giftRegistry.type;
                arrayItem.manualGift = false; // we know that the item was added from a gift registry.

                const registryItem = {};
                registryItem.id = item.giftRegistry.id;
                registryItem.name = item.giftRegistry.name;
                registryItem.type = item.giftRegistry.type;

                orderGiftRegistries.registries.push(registryItem);
                orderGiftRegistries.itemsPresent = true;
            }
            orderGiftRegistries.items.push(arrayItem);
        });
    }

    /* istanbul ignore else */
    if (orderGiftRegistries.itemsPresent) {
        orderGiftRegistries.registries = uniqWith(orderGiftRegistries.registries, isEqual);
    }

    orderGiftRegistries.registries &&
        orderGiftRegistries.registries.length !== 1 &&
        (orderGiftRegistries.itemsPresent = false);

    return orderGiftRegistries;
}

export function isOOSItem(orderItem) {
    const formattedStatus =
        orderItem && orderItem.inventory.status && orderItem.inventory.status.replace(/\s/g, '');
    const inventoryStatus = InventoryStatus[`${formattedStatus}`];
    return inventoryStatus && inventoryStatus.desc === 'Out of Stock';
}

/*
 * This function will only return true or false based on OAuth token down or not.
 */
export function isTokenApiDown() {
    return (
        TokenProvider.get('TOKEN_API_STATUS') === 'true' ||
        TokenProvider.get('TOKEN_API_STATUS') === true
    );
}

/*
 * This function is to read the required cookies for cart merge and create custom headers object, to support Legacy adapter.
 * param: cookieList => Array of cookie names to read.
 */
export function getLegacyAdapterCookies(cookieList) {
    const customHeaders = {};
    each(cookieList, (cookie) => {
        const cookieValue = Cookies.load(cookie);
        /* istanbul ignore else */
        if (!isEmpty(cookieValue)) {
            customHeaders[cookie] = cookieValue;
        }
    });

    return customHeaders;
}

export function isAurora() {
    const auroraCookie = Cookies.load('Aurora');
    return auroraCookie && auroraCookie.includes('microservice');
}

export function createLogPayload(data, payload) {
    if (!payload) {
        // eslint-disable-next-line no-param-reassign
        payload = {};
    }
    if (!payload.attributes) {
        // eslint-disable-next-line no-param-reassign
        payload.attributes = [];
    }
    payload.attributes.push({
        name: data.name,
        value: data.value,
        type: data.type,
    });
    return payload;
}

export function createAnalycticsSplunkParams(digitalData) {
    const productDA = [];
    digitalData.product.map((item) => {
        const pi = item.productInfo;
        productDA.push(pi.productPPID);
        /* istanbul ignore else */
        if (pi.productLotId && pi.productLotId.length > 0) {
            productDA.push(pi.productLotId.join('plid:'));
        }
        productDA.push(`sku:${pi.productSKU}`);
        productDA.push(`csp:${pi.productCurrentSellingPrice}`);
        productDA.push(`sp:${pi.productSurchargePrice}`);
        productDA.push(`pQ:${pi.productQuantity}`);
        productDA.push(`pCA:${pi.productCouponAmount}`);
        productDA.push(`pQD:${pi.productQuantityDiscount}`);
        productDA.push(`pFee:${pi.productFee}`);
        productDA.push(`pAD:${pi.productAssociateDiscount}`);
        return item;
    });
    /* istanbul ignore else */
    if (digitalData.transaction) {
        /* istanbul ignore else */
        if (digitalData.transaction.total) {
            productDA.push(`tT:${digitalData.transaction.total.totalTax}`);
            productDA.push(`tSC:${digitalData.transaction.total.shippingCost}`);
            productDA.push(`tTx:${digitalData.transaction.total.totalTax}`);
        }
        /* istanbul ignore else */
        if (digitalData.transaction.attributes) {
            productDA.push(`tTID:${digitalData.transaction.attributes.transactionID}`);
        }
    }
    return productDA;
}
export function logDAErrorUtil(params) {
    logDAError(params);
}

export function logBootstrapPresentInSplunk(digitalData, enableClickStreamLogs) {
    try {
        const pageOCSPlunkAttributes = {
            name: 'BSTP',
            value: window.Bootstrapper ? 'Y' : 'N',
            type: 'string',
        };
        let payload2 = createLogPayload(pageOCSPlunkAttributes);
        const orderID = {
            name: 'OID',
            value: getOrderID(digitalData),
            type: 'string',
        };
        payload2 = createLogPayload(orderID, payload2);
        const params = { payload: payload2 };
        enableClickStreamLogs
            ? CustomErrorLogger.triggerCustomErrorLog(params)
            : logDAErrorUtil(params);
        return true;
    } catch (error) {
        /* istanbul ignore next */
        return false;
    }
}

export function getOrderID(digitalData) {
    /* istanbul ignore else */
    if (
        digitalData &&
        digitalData.transaction &&
        digitalData.transaction.attributes &&
        digitalData.transaction.attributes.transactionID
    ) {
        return digitalData.transaction.attributes.transactionID;
    }
    return 'NFOID';
}

export function getOrigin(checkoutState) {
    let origin = '';
    if (__SERVER__) {
        origin = 'checkout';
        return origin;
    }
    if (window.location.pathname === URL_CART_PAGE) {
        origin = 'cart';
        return origin;
    }
    if (window.location.pathname === URL_REVIEW_PAGE) {
        origin = 'review';
        return origin;
    }
    try {
        const sdpuIndex = checkoutState.SDPU.index || 0;
        const shippingIndex = checkoutState.shipping.index || 0;
        const paymentIndex = checkoutState.payment.index || 0;
        const selectedIndex = checkoutState.selectedAccordionIndex || 0;
        switch (selectedIndex) {
            case sdpuIndex:
            case shippingIndex:
                origin = 'shipping';
                break;
            case paymentIndex:
                origin = 'billing';
                break;
            default:
                origin = 'checkout';
        }
    } catch (err) {
        console.warn('err during determine current accordion', err);
    }
    return origin;
}

export function getURLParameterBykey(name, url = window.location.href) {
    // eslint-disable-next-line no-param-reassign
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function logAdBlockerAndDNTInSplunk(digitalData, isBlockingAds, enableClickStreamLogs) {
    try {
        const TLTSID = {
            name: 'TLTSID',
            value: Cookies.load('TLTSID'),
            type: '',
        };
        let payload2 = createLogPayload(TLTSID);
        const orderId = {
            name: 'orderId',
            value: getURLParameterBykey('OrderId', window.location.href),
            type: '',
        };
        payload2 = createLogPayload(orderId, payload2);
        const jcpOrderID = {
            name: 'jcpOrderID',
            value: getOrderID(digitalData),
            type: '',
        };
        payload2 = createLogPayload(jcpOrderID, payload2);
        const userAgent = {
            name: 'userAgent',
            value: navigator.userAgent,
            type: '',
        };
        payload2 = createLogPayload(userAgent, payload2);
        const DPJSESSIONID = {
            name: 'DPJSESSIONID',
            value: Cookies.load('DPJSESSIONID'),
            type: '',
        };
        payload2 = createLogPayload(DPJSESSIONID, payload2);
        const AccountID = {
            name: 'ACCOUNT_ID',
            value: Cookies.load('ACCOUNT_ID'),
            type: '',
        };
        payload2 = createLogPayload(AccountID, payload2);
        const DNT = {
            name: 'DNT',
            value: navigator.doNotTrack,
            type: '',
        };
        payload2 = createLogPayload(DNT, payload2);
        const adBlocking = {
            name: 'ADBlock',
            value: isBlockingAds ? 'Y' : 'N',
            type: '',
        };
        payload2 = createLogPayload(adBlocking, payload2);
        const params = { payload: payload2 };
        enableClickStreamLogs
            ? CustomErrorLogger.triggerCustomErrorLog(params)
            : logDAErrorUtil(params);
        return true;
    } catch (/* istanbul ignore next */ error) {
        return false;
    }
}

/* istanbul ignore next */
export function AdBlockerTestandLog(digitalData) {
    try {
        const adBlockTester = document.createElement('div');
        adBlockTester.innerHTML = '&nbsp;';
        adBlockTester.className = 'adsbox';
        adBlockTester.height = '1px';
        adBlockTester.width = '1px';
        /* istanbul ignore next */
        window.setTimeout(
            () /* istanbul ignore next */ => {
                if (adBlockTester.offsetHeight === 0) {
                    setTimeout(() => {
                        // blocking ads
                        logAdBlockerAndDNTInSplunk(digitalData, true);
                    }, 1500);
                } else {
                    // not blocking ads
                    logAdBlockerAndDNTInSplunk(digitalData, false);
                }
                document.body.removeChild(adBlockTester);
            },
            1500
        );
        document.body.appendChild(adBlockTester);
        return true;
    } catch (/* istanbul ignore next */ error) {
        return false;
    }
}

/**
 * This method handles redirection to specific sections like shipping, payment or cart page based on
 * subCode returned by Aurora micro-services
 * @exceptions Object
 * @isReviewPage {true / false}
 *
 * @memberof Utils
 */
export function handleAuroraRedirection(exceptions, enableCheckoutRedesign) {
    // TODO Move these codes to config/preferences
    const billingErrorSubCodes = [
        'BILLING',
        'BILLING_GC',
        'BILLING_CC',
        'BILLING_PAYPAL',
        'BILLING_APPLEPAY',
    ];
    const shippingErrorSubCodes = ['DELIVERY', 'DELIVERY_STH', 'DELIVERY_STS'];
    if (!enableCheckoutRedesign) {
        shippingErrorSubCodes.push('DELIVERY_BOPIS');
    }
    let errorHandled = false;
    if (!isEmpty(exceptions)) {
        const errorSubCodes = map(exceptions, 'errorSubcode');
        // If errorSubCode has billing redirect user to billing
        if (
            !isEmpty(intersection(billingErrorSubCodes, errorSubCodes)) &&
            isEmpty(intersection(shippingErrorSubCodes, errorSubCodes))
        ) {
            errorHandled = true;
        }
    }
    return errorHandled;
}

/**
 * Return static image path
 * @context Object
 * @imageName String
 */
export function imagePath(context = {}, imageName) {
    // NOSONAR
    // https://m.jcpenney.com/static-checkout/assets/static/images/icon-giftcard.svg
    let path = `${context.staticRoute}/assets/static/images/${imageName}`;
    if ((context.featureFlags || {}).serveAppStaticFromExternalHost) {
        // https://www.static-jcpenney.com/prod4/yoda-checkout/assets/static/images/icon-giftcard.svg
        path = `${context.staticRoutes.app}/assets/static/images/${imageName}`;
    }
    return path;
}

/**
 * Return true for Diamond vault product or Bali Blind
 * @param subdivision
 * @returns {boolean}
 */
export function isExtensionRequired(subdivision) {
    return subdivision === '145' || subdivision === '724' || subdivision === '250';
}

export function getViewPort() {
    let viewportSize = '';
    if (window && window.innerWidth) {
        const width = window.innerWidth;
        if (width < 600) {
            viewportSize = 'small';
        } else if (width >= 600 && width < 1024) {
            viewportSize = 'medium';
        } else if (width >= 1024 && width < 1440) {
            viewportSize = 'large';
        } else {
            viewportSize = 'xlarge';
        }
    }
    return viewportSize;
}

export function setGlobalErrorHandler(section, actionCreator) {
    /* istanbul ignore next */
    const handler = (event) => {
        // setTimeout is needed here to handle global error after boundary component did it
        setTimeout(() => {
            const { error } = event;
            // eslint-disable-next-line no-underscore-dangle
            if (error && !error._boundaryAlreadyHandled) {
                const accountId = TokenProvider.get(ACCOUNT_ID);
                actionCreator([
                    {
                        name: `GLOBAL_ERROR_${section}_${accountId}`,
                        value: error.stack || 'Unhandled exception',
                    },
                ]);
            }
        });
    };

    window.addEventListener('error', handler);

    return () => window.removeEventListener('error', handler);
}

export function applepayUpdateConstructor(response) {
    const draftResp = response.data;
    const update = {
        newShippingMethods: [],
        newLineItems: [],
        newTotal: {
            label: 'JCPenney',
            amount: 0,
        },
    };
    let selectedShippingMethod = '';
    draftResp.totals.forEach((total) => {
        /* istanbul ignore else */
        if (total.type === 'SUB TOTAL') {
            update.newLineItems.push({
                label: total.type,
                amount: total.amount,
            });
        }
        /* istanbul ignore else */
        if (total.type === 'BALANCE') {
            update.newTotal.amount = total.amount;
        }
    });
    const rewards = {
        count: 0,
        amount: 0,
    };
    let paymentRestrictedCouponMessage = null;
    draftResp.adjustments.forEach((adj) => {
        /* istanbul ignore else */
        if (adj.rewardCategory === ADJUSTMENT_TYPE_NEW_CUSTOMER) {
            paymentRestrictedCouponMessage = APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE;
        }
        if (adj.code === 'COUPON' && adj.value && adj.amount) {
            if (!isEmpty(adj.message)) {
                paymentRestrictedCouponMessage = `${APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE} ${adj.value}`;
            }
            update.newLineItems.push({
                label: `DISCOUNT: ${adj.value}`,
                amount: -adj.amount,
            });
        }
        if (adj.code === 'ASSOCIATEDISCOUNT' && adj.amount) {
            update.newLineItems.push({
                label: 'DISCOUNT: ASSOC. DISCOUNT',
                amount: -adj.amount,
            });
        }
        if (adj.code === 'REWARDSCERT' && adj.value && adj.amount) {
            rewards.count += 1;
            rewards.amount += adj.amount;
        }
    });
    if (paymentRestrictedCouponMessage) {
        update.newLineItems.unshift({
            label: paymentRestrictedCouponMessage,
            amount: '0.0',
            type: 'pending',
        });
    }
    /* istanbul ignore else */
    if (rewards.amount) {
        const rewardLabel = rewards.count > 1 ? `REWARDS(${rewards.count})` : 'REWARD';
        update.newLineItems.push({
            label: `DISCOUNT: ${rewardLabel}`,
            amount: -rewards.amount,
        });
    }
    if (draftResp.delivery.groups) {
        const shippingGroup = draftResp.delivery.groups.filter((d) => d.type === 'HOME')[0];
        const serviceLevels = get(shippingGroup, 'serviceLevels.data');
        /* istanbul ignore else */
        if (serviceLevels) {
            serviceLevels.forEach((dMethod) => {
                /* istanbul ignore else */
                if (dMethod.code && dMethod.duration) {
                    update.newShippingMethods.push({
                        label: dMethod.code,
                        amount: dMethod.charge,
                        detail: dMethod.duration,
                        identifier: shippingGroup.id,
                        selected: dMethod.selected,
                    });
                    if (dMethod.selected) {
                        selectedShippingMethod = dMethod;
                    }
                }
            });
            update.newShippingMethods.sort((sMethod) => !sMethod.selected);
        }
    }
    const chargesUIMap = {
        'OVERSIZE SURCHARGE': 'OVERSIZED ITEM CHARGE',
        'ROUND UP': 'ROUND UP FOR CHARITY',
    };
    const chargesSort = ['SHIPPING AND HANDLING', 'OVERSIZE SURCHARGE', 'TAX', 'ROUND UP'];
    draftResp.charges.sort((a, b) => chargesSort.indexOf(a.type) - chargesSort.indexOf(b.type));
    draftResp.charges.forEach((charge) => {
        /* istanbul ignore else */
        if (charge.type && charge.amount !== 'TBD') {
            let label = chargesUIMap[charge.type] ? chargesUIMap[charge.type] : charge.type;
            if (charge.type === 'SHIPPING AND HANDLING' && selectedShippingMethod) {
                label = selectedShippingMethod.code;
            }
            update.newLineItems.push({
                label,
                amount: charge.amount,
            });
        }
    });
    const giftCards = get(draftResp, 'billing.unnamed.giftCards', []);
    if (!isEmpty(giftCards)) {
        let giftCardAmount = 0;
        let count = 0;
        giftCards.forEach((giftCard) => {
            giftCardAmount += giftCard.amount;
            count += 1;
        });
        const label = count > 1 ? `GIFT CARD (${count})` : 'GIFT CARD';
        update.newLineItems.push({
            label,
            amount: -giftCardAmount,
        });
    }
    return update;
}

/**
 * Construct apple error object list.
 * Should ignore apple pay payment related error.
 * @param errors
 * @return {Array}
 */
export function appleErrorConstructor(errors) {
    const applePayErrorList = [];
    forEach(errors, (error) => {
        let errorCode = null;
        let contactField = null;
        let errorMessage = error.errorMessage || '';
        if (
            error.errorSubcode === 'DELIVERY_STH' &&
            error.errorCode === 'API_ERR_FIELD_HOME_INTL_COUNTRY_NOT_SUPPORTED'
        ) {
            errorCode = 'addressUnserviceable';
            contactField = 'postalAddress';
        } else if (
            APPLEPAY_ERROR_MAP[error.errorSubcode] &&
            APPLEPAY_ERROR_MAP[error.errorSubcode][error.errorCode]
        ) {
            errorCode = APPLEPAY_ERROR_MAP[error.errorSubcode].code;
            const errorInfo = APPLEPAY_ERROR_MAP[error.errorSubcode][error.errorCode];
            contactField = errorInfo.contactField;
            if (errorInfo.messageOverride) {
                errorMessage = errorInfo.customErrMsg;
            }
        } else if (error.errorSubcode === 'DELIVERY_STH') {
            errorCode = 'shippingContactInvalid';
            contactField = 'postalAddress';
        }
        if (errorCode && contactField) {
            const applePayError = new window.ApplePayError(errorCode, contactField, errorMessage);
            applePayErrorList.push(applePayError);
        }
    });
    return applePayErrorList;
}

/**
 * JIRA Story Id: MCYODA-18029
 * Temp Pass Cart Unique Id to UID Coookie as per Aurora Team discussion.
 * Once DA Team confirm to remove this logic to DA then to pass Cart Unique Id to Digital Data's Shopping bag.
 */
export function updateCartUID(cartDetailsResponse) {
    const analyticsAttributes = get(cartDetailsResponse, 'data.analyticsAttributes', []);
    const orderUID = find(analyticsAttributes, { type: ANALYTICS_ORDER_UID });
    if (orderUID) {
        Cookies.save('UID', orderUID.value);
    }
}

/**
 * updateUserZipcode, add or update DP_USER_DEFAULT_ADDRESS_ZIP cookie
 * @param cartDetailsResponse contains entire GET Order API Response
 * Help of this Add or Edit Address zipcode update into DP_USER_DEFAULT_ADDRESS_ZIP Cookie
 * Update if address country as US.
 */
export function updateUserZipcode(cartDetailsResponse) {
    const deliveryGroup = get(cartDetailsResponse, 'data.delivery.groups', []);
    // To get for BOPIS + STH || STH
    const shippingDeliveryGroup = find(deliveryGroup, { type: 'HOME' });
    const shippingAddressZipcode = get(shippingDeliveryGroup, 'address.zip', '');
    const shippingAddressCountry = get(shippingDeliveryGroup, 'address.country', '');
    !isEmpty(shippingAddressZipcode) &&
        (shippingAddressCountry === 'US' || shippingAddressCountry === 'AP') &&
        setValue('DP_USER_DEFAULT_ADDRESS_ZIP', shippingAddressZipcode, true);
}

/**
 * update DP_USER_DEFAULT_ADDRESS_ZIP cookie based STH item level zipcode
 * @param cartDetailsResponse contains entire GET Order API Response
 */
export function updateUserZipcodeBasedSTHItem(cartDetailsResponse) {
    const items = get(cartDetailsResponse, 'data.bag.items', []);
    let sthDeliveryInfo = {};
    find(items, (item) => {
        sthDeliveryInfo = find(item.deliveryOptions, { code: 'HOME', selected: true });
        return sthDeliveryInfo;
    });
    const shippingAddressZipcode = get(sthDeliveryInfo, 'zipcode');
    shippingAddressZipcode && setValue('DP_USER_DEFAULT_ADDRESS_ZIP', shippingAddressZipcode, true);
}

/**
 * getOrderShippingZipcode return order zipcode order has HOME shipping type
 * @param orderShippingGroupsInfo contains Shipping delivery Groups
 * Help of this return Order Zipcode to display on Cart & Checkout. Else to display AK Zipcode
 */
export function getOrderShippingZipcode(orderShippingGroupsInfo) {
    const STHShippingGroup = find(orderShippingGroupsInfo, { type: 'HOME' }) || {};
    return (
        (STHShippingGroup.address &&
            (STHShippingGroup.address.country === 'US' ||
                STHShippingGroup.address.country === 'AP') &&
            STHShippingGroup.address.zip) ||
        ''
    );
}

export function isCaliforniaState(orderShippingGroupsInfo) {
    const STHShippingGroup = find(orderShippingGroupsInfo, { type: 'HOME' }) || {};
    return STHShippingGroup.address && STHShippingGroup.address.state === 'CA';
}

/**
 * getOrderShippingType return order type as "HOME | STORE | BOPIS"
 * @param orderShippingGroupsInfo contains Shipping delivery Groups
 * Help of this return Order type to display AK Zipcode on Cart & Checkout
 */
export function getOrderShippingType(orderShippingGroupsInfo) {
    let orderShippingType = '';
    forEach(orderShippingGroupsInfo, (group) => {
        if (orderShippingType) {
            if (group.type === 'BOPIS') {
                orderShippingType = `${group.type}|${orderShippingType}`;
            } else {
                orderShippingType = `${orderShippingType}|${group.type}`;
            }
        } else {
            orderShippingType = group.type;
        }
    });
    return orderShippingType;
}

/**
 * Check some of item is OOS or not
 * @param exceptions
 * @return {boolean}
 */
export function isSomeOfItemOOS(exceptions) {
    return !!find(exceptions, { errorCode: 'ORDER_HAS_OUT_OF_STOCK' });
}

/**
 * Check all item is OOS or not
 * @param exceptions
 * @return {boolean}
 */
export function isAllItemOOS(exceptions) {
    return !!find(exceptions, { errorCode: 'ALL_ITEMS_OUT_OF_STOCK' });
}

/**
 * Return order total amount
 * @param totals
 * @return {number}
 */
export function getOrderTotal(totals) {
    const orderAmountInfo = find(totals, { type: 'ORDER AMOUNT' }) || {};
    return orderAmountInfo.amount || 0.0;
}

/**
 * Return true if apple pay enabled and apple pay eligible from order api and balance is not 0 and not all item oos
 * @param context
 * @param orderResponse
 * @return {boolean}
 */
export function isOrderEligibleApplePay(context, orderResponse) {
    let orderEligibleApplePay = false;
    const isApplePayEnabled = get(context, 'featureFlags.applepay');
    if (isApplePayEnabled) {
        const availableStrategies = orderResponse.headers.get('X-AVAILABLE_STRATEGIES');
        const isOrderEligible =
            availableStrategies && availableStrategies.indexOf('apple-pay') !== -1;
        if (isOrderEligible) {
            const orderTotals = get(orderResponse, 'data.totals', []);
            const orderAmount = find(orderTotals, { type: 'BALANCE' });
            const orderBalanceExist = orderAmount && orderAmount.amount > 0;
            if (orderBalanceExist) {
                const discontinuedOOSInfo = getDataForOOS(orderResponse.data.bag.items);
                const {
                    isAllItemsDiscontinued,
                    isAllItemsOos,
                    isAllItemsDiscontinuedAndOOS,
                } = discontinuedOOSInfo;
                const enableDiscontinuedItemsMessaging = get(
                    context,
                    'featureFlags.enableDiscontinuedItemsMessaging',
                    false
                );
                const exceptions = get(orderResponse, 'data.status.exceptions', []);
                const isAllItemNotOOS = enableDiscontinuedItemsMessaging
                    ? !(isAllItemsDiscontinued || isAllItemsOos || isAllItemsDiscontinuedAndOOS)
                    : !isAllItemOOS(exceptions);
                if (isAllItemNotOOS) {
                    orderEligibleApplePay = true;
                }
            }
        }
    }
    return orderEligibleApplePay;
}

export function isPayPalStrategiesAvailable(orderResponse) {
    const availableStrategies = orderResponse.headers.get('X-AVAILABLE_STRATEGIES');
    return availableStrategies && availableStrategies.indexOf('paypal') !== -1;
}

/**
 * MCYODA-21044
 * Return true if cart BOPIS item has curbsidePickUpAvailable as true or ocp STORE item has curbsidePickUpAvailable as true
 * @param orderItems
 * @return {boolean}
 */
export function getCurbsideEligible(orderItems = [], pageName) {
    if (isEmpty(orderItems)) {
        return false;
    }
    const curbSideItem = find(orderItems, (item) => {
        const isCurbSideStoreExistInDelivery = find(
            item.deliveryOptions,
            (option) =>
                option.selected &&
                (option.code === 'BOPIS' || (option.code === 'STORE' && pageName === 'ocp')) &&
                option.curbsidePickUpAvailable
        );
        return !!isCurbSideStoreExistInDelivery;
    });
    return !!curbSideItem;
}

/**
 * Return new checkout redesign enabled or not
 * @param context
 * @return boolean
 */
export function isNewCheckoutExperience(context) {
    const isForceCheckoutRedesignEnabled = get(context, 'featureFlags.enableForceCheckoutRedesign');
    if (isForceCheckoutRedesignEnabled) {
        return true;
    }
    const isFeatureEnabled = get(context, 'featureFlags.enableCheckoutRedesign');
    if (isFeatureEnabled) {
        let isLoadedFromAurora = false;
        let akamaiThrottlingCookie = null;
        if (__SERVER__) {
            akamaiThrottlingCookie = get(context, 'headers.cookies.DPCPT');
            const auroraCookie = get(context, 'headers.cookies.Aurora');
            isLoadedFromAurora = auroraCookie && auroraCookie.includes('microservice');
        } else {
            akamaiThrottlingCookie = Cookies.load('DPCPT');
            isLoadedFromAurora = isAurora();
        }
        if (akamaiThrottlingCookie && isLoadedFromAurora) {
            // DPCPT = |CP1Y|CP2N|CP3Y
            const akamaiThrottlingCookieList = akamaiThrottlingCookie.split('|');
            return akamaiThrottlingCookieList.includes('CP3Y');
        }
    }
    return false;
}

export function isNewBOPISmessageEnabled(enableBopisPickupMessage) {
    const akamaiThrottlingCookie = Cookies.load('DPCPT');
    const akamaiThrottlingCookieList = akamaiThrottlingCookie && akamaiThrottlingCookie.split('|');
    return (
        enableBopisPickupMessage &&
        akamaiThrottlingCookieList &&
        akamaiThrottlingCookieList.includes('CP5Y')
    );
}

/**
 * Redirect to car page if user trying land in old checkout flow with checkout redesign enabled or
 * trying land in new checkout flow with checkout redesign disabled.
 * @param location
 * @param setRedirectUrlAction
 * @param redirectToNew
 * @return {string}
 */
export function redirectToOldNewCheckoutFlow(location, setRedirectUrlAction, redirectToNew) {
    let redirectTo = URL_CHECKOUT_PAYMENT;
    const oldQueryParamNewURLMap = {};
    oldQueryParamNewURLMap[URL_SHIPPING_PAGE] = URL_CHECKOUT_SHIPPING;
    oldQueryParamNewURLMap[URL_PAYMENT_PAGE] = URL_CHECKOUT_PAYMENT;
    if (redirectToNew) {
        const query = makeQuery(location.search);
        if (query.action && query.from === 'Cart') {
            redirectTo = oldQueryParamNewURLMap[query.action];
        } else if (query.action) {
            /**
             * Handling place order errors and landing review page errors | redirect to optimization
             * design and URL changes
             */
            redirectTo = `${oldQueryParamNewURLMap[query.action]}?from=review`;
        } else if (query.token) {
            /**
             * Handling PayPal Cancel callback action | redirect to new form optimization design
             */
            redirectTo = `${URL_CHECKOUT_PAYMENT}?token=${query.token}`;
        }
    } else {
        redirectTo = URL_CHECKOUT_PAGE;
    }
    if (__SERVER__) {
        setRedirectUrlAction({ url: redirectTo });
    } else {
        window.location = redirectTo;
    }
}

/**
 * Return true if login as register user else return false
 * @param 'context-header-cookie-DP_USER_STATE'.
 * @return {boolean}
 */
export function checkUserLoggedIn(context) {
    /* istanbul ignore else */
    if (__SERVER__) {
        return get(context, 'headers.cookies.DP_USER_STATE', '') === '1';
    }
    return User.isUserLoggedIn();
}

export function handleCartExceptions(exception) {
    const bagError = find(exception, { errorCode: 'SRV_BAG_NOTFOUND', errorSubcode: 'BAG' });
    if (bagError) {
        window.location.href = '/cart';
    }
}

export function isDiscontinuedItem(orderItem) {
    return orderItem && orderItem.discontinued;
}

export function isBOPISItem(item = {}) {
    return find(item.deliveryOptions, {
        code: 'BOPIS',
        selected: true,
    });
}

export function isShipAloneAvailable(items) {
    return !isEmpty(
        find(items, (item) => !isBOPISItem(item) && get(item, 'product.shipAlone', false))
    );
}

export function isDistantBillingAddress(warnings, codeType) {
    return !isEmpty(find(warnings, { code: codeType }));
}

export function getSDPUItems(orderItems, skuIds) {
    const result = [];
    forEach(orderItems, (element) => {
        find(skuIds, (SKUItem) => {
            if (SKUItem === element.sku.id) {
                const bopisItem = this.isBOPISItem(element);
                bopisItem && result.push(element);
            }
            return result;
        });
    });
    return result;
}

export function mapOOSMessage(discontinuedOOSDetails) {
    const { isOOS, isDiscontinued, isOOSSDPU } = discontinuedOOSDetails;
    let discontinuedOOSMessage = {};
    const isOOSSDPUItem = isOOS && isOOSSDPU;
    const isOOSNOSDPU = isOOS && !isOOSSDPU;

    if (isDiscontinued && !isOOS) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.DISCONTINUED_ITEMS;
    } else if (isDiscontinued && isOOSNOSDPU) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.DISCONTINUE_OOS_NOSDPU;
    } else if (!isDiscontinued && isOOSNOSDPU) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.OOS_NOSDPU;
    } else if (isDiscontinued && isOOSSDPUItem) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.DISCONTINUE_OOS_SDPU;
    } else if (!isDiscontinued && isOOSSDPUItem) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.OOS_SDPU;
    } else {
        discontinuedOOSMessage = OOS_MESSAGES;
    }
    return discontinuedOOSMessage;
}

export function getDataForOOS(items) {
    const discontinuedOOSDetails = {
        oosItemProducts: [],
        discontinuedItemProducts: [],
        discontinuedOOSMessage: {},
    };
    const OOSInfo = {
        isOOS: false,
        isDiscontinued: false,
        isOOSSDPU: false,
    };

    map(items, (item) => {
        const { product, id: cartItemId, attributes } = item;
        const pushObj = { ...product, cartItemId, attributes };

        /* istanbul ignore else */
        if (item.discontinued) {
            discontinuedOOSDetails.discontinuedItemProducts.push(pushObj);
            OOSInfo.isDiscontinued = true;
        } else if (isOOSItem(item)) {
            discontinuedOOSDetails.oosItemProducts.push(pushObj);
            OOSInfo.isOOS = true;
            if (!OOSInfo.isOOSSDPU) {
                OOSInfo.isOOSSDPU = !!isBOPISItem(item);
            }
        }
    });
    discontinuedOOSDetails.discontinuedOOSMessage = mapOOSMessage(OOSInfo);
    const isAllItemsOos = items.length === discontinuedOOSDetails.oosItemProducts.length;
    const isAllItemsDiscontinued =
        items.length === discontinuedOOSDetails.discontinuedItemProducts.length;
    const { oosItemProducts, discontinuedItemProducts } = discontinuedOOSDetails;
    const isAllItemsDiscontinuedAndOOS =
        items.length === concat(oosItemProducts, discontinuedItemProducts).length;
    const result = {
        isAllItemsOos,
        isAllItemsDiscontinued,
        discontinuedOOSDetails,
        isAllItemsDiscontinuedAndOOS,
    };
    return result;
}

export function getCartItemById(items = [], id = '') {
    return items.find((item) => item.id === id);
}

/**
 * Check whether phone or credit card field
 * @param enableInputFieldMaskFix
 * @param fieldName
 * @param inputType
 * @param value
 */
export function getMaskEligibleInfo(enableInputFieldMaskFix, fieldName, type, value) {
    if (enableInputFieldMaskFix.includes(fieldName)) {
        if (['phoneNumber', 'phone'].includes(fieldName) && type === 'tel') {
            return {
                enableInputFieldMask: true,
                inputType: 'phone',
            };
        }
        if (fieldName === 'creditCardNumber' && type === 'tel') {
            const isCreditCardEditField = value && /\*/g.test(value); // The credit card value will be something like '****8888' during the edit.
            return {
                enableInputFieldMask: !isCreditCardEditField,
                inputType: 'creditCard',
            };
        }
    }
    return {};
}

/**
 * Handle data preparation for eligible input field on key down event
 * @param e
 * @param enableInputFieldMask
 * @param inputType
 */
export function getInputKeyDownInfo(e, enableInputFieldMask, inputType) {
    const { key = '', keyCode = '', target = {}, target: { selectionStart } = {} } = e;
    const supportInputFieldMask =
        enableInputFieldMask && key && keyCode && 'selectionStart' in target;
    if (supportInputFieldMask) {
        return {
            keyCode,
            supportInputFieldMask,
            inputType,
            selectionStart,
        };
    }
    return {};
}

/**
 * Handle cursor position on input key up event
 * @param event
 * @param inputKeyEvents
 */
export function handleCursorPosition(event, inputKeyEvents) {
    const { selectionStart = '', inputType = '' } = inputKeyEvents;
    const { target = {}, key = '' } = event;

    if (
        ['phone', 'creditCard'].includes(inputType) &&
        selectionStart >= 0 &&
        key &&
        /\d/.test(key)
    ) {
        let curPosition = selectionStart + 1;
        if (inputType === 'phone') {
            // Increment cursor position if it not numeric digit (xxx) xxx-xxxx
            if ([1, 6, 9, 10].includes(curPosition)) {
                curPosition += 1;
            } else if ([4, 5].includes(curPosition)) {
                curPosition += 2;
            }
        } else if (inputType === 'creditCard') {
            // Increment cursor position if it not numeric digit xxxx xxxx xxxx xxxx
            if ([5, 10, 15].includes(curPosition)) {
                curPosition += 1;
            }
        }
        target && target.setSelectionRange(curPosition, curPosition);
    }
}

/**
 * Check whether delete or backspace key triggered
 * @param inputType
 * @param InputKeyEvents
 */
export function isInputDelKeyTriggered(inputType, InputKeyEvents) {
    const { keyCode = '' } = InputKeyEvents;
    return (
        inputType &&
        ['phone', 'creditCard'].includes(inputType) &&
        keyCode &&
        [8, 46].includes(keyCode)
    );
}

/**
 * Remove last numberic digit if phone number numeric digit length exceed 10
 * Ex. input format (8981 908-2222 or (898)2908-2222 or 9898) 908-2222 or (898) 90852222
 * @param value
 */
export function getFirstTenDigitOfPhone(value) {
    if (value && value.replace(/\D/g, '').length === 11) {
        return value.slice(0, -1);
    }
    return value;
}

/**
 * Return IRIS search name for selected sku
 */
export function getIRISSearchTerm(productType, carePlanWarrantyMap) {
    const selectedProductType = productType && productType.trim().toLowerCase();
    const irisSearchTerm = Object.keys(carePlanWarrantyMap).find((item) =>
        carePlanWarrantyMap[item].find(
            (mapItem) => mapItem.trim().toLowerCase() === selectedProductType
        )
    );
    return irisSearchTerm || '';
}

/**
 * Detects whether the credit card on order is a klarna type
 */
export function isKlarnaOnOrder(orderDetailsInfo = {}) {
    const billingObj = orderDetailsInfo?.data?.billing || orderDetailsInfo;
    return (
        /klarna/i.test(
            get(billingObj, 'creditCards.cards[0].subtype') || get(billingObj, 'subtype', '')
        ) || false
    );
}

export function displayNortonSealEvent() {
    try {
        const e = new CustomEvent('displayNortonSeal', {});
        document.dispatchEvent(e);
    } catch (err) {
        /* istanbul ignore next */
        console.log(err);
    }
}

export function getDeviceInfo() {
    const deviceInfo = {};
    if (window?._bcn?.dvc) {
        deviceInfo.deviceTransactionId = window._bcn.dvc.getTID();
    }
    if (window?._bcn) {
        deviceInfo.ubaToken = window._bcn.getToken();
        deviceInfo.ubaSessionId = window._bcn.getUbaSessionId();
        deviceInfo.ubaPageId = window._bcn.getPageId();
        deviceInfo.ubaEvents = window._bcn.getEvents();
    }
    return deviceInfo;
}
